/* eslint-disable no-unused-vars */
import { useCallback, useState, useMemo, forwardRef, useEffect } from 'react';
import { MenuItem, DropdownMenu, IconButton } from 'components';
import { PauseAction, Duplicate, Pen, DotMenuIcon, StartIcon } from 'assets/icons';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { getDynamicUrl, showPolipop } from 'utils';
import { routes } from 'config';
import { campaignReportsAPI } from 'services/campaignReports.service';

const getListOfMenuItems = ({ campaign_status, has_banners, has_tracking, bid_type }) => {
  if (campaign_status === 9) return ['duplicate'];
  if (campaign_status === 0) return ['pause_now', 'edit_campaign', 'duplicate'];
  if (campaign_status == 3) {
    if (bid_type === 3 && has_banners === 0 && has_tracking === 0) return ['edit_campaign'];
    if (bid_type === 2 && has_banners === 0) return ['edit_campaign'];
    return ['play_now', 'edit_campaign', 'duplicate'];
  }
  if (campaign_status === 8 || campaign_status === 4) return ['edit_campaign', 'duplicate'];
};

export const DotsMenu = ({ campaign_status, has_banners, has_tracking, bid_type, isWebsite }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { cmp_id } = useParams();
  const navigate = useNavigate();

  const [updateCampaignStatus, resultApp] = campaignReportsAPI.useUpdateCampaignStatusMutation();
  const [updateWebCampaignStatus, resultWeb] =
    campaignReportsAPI.useUpdateWebCampaignStatusMutation();

  const result = isWebsite ? resultWeb : resultApp;

  useEffect(() => {
    if (result.isError) {
      showPolipop(result);
    }
  }, [result.status]);

  const menuItemsList = useMemo(
    () => getListOfMenuItems({ campaign_status, has_banners, has_tracking, bid_type }),
    [campaign_status, has_banners, has_tracking, bid_type],
  );

  const statusAction = useCallback(
    (status) => {
      setIsOpen(false);
      const statusReq = {
        campaignId: cmp_id,
        status: status,
      };
      if (isWebsite) {
        updateWebCampaignStatus(statusReq);
      } else {
        updateCampaignStatus(statusReq);
      }
    },
    [isWebsite],
  );

  const duplicateAction = useCallback(() => {
    setIsOpen(false);
    let url = getDynamicUrl(
      routes.list.find((route) => route.id === 'campaign/duplicateCampaign').url,
      {
        cmp_id,
      },
    );
    navigate(url);
  }, []);

  const editAction = useCallback(() => {
    setIsOpen(false);
    let url = getDynamicUrl(routes.list.find((route) => route.id === 'campaign/editCampaign').url, {
      cmp_id,
    });
    navigate(url);
  }, [cmp_id]);

  const allMenuItems = useMemo(
    () => [
      {
        menu_name: 'Play Now',
        id: 'play_now',
        icon: StartIcon,
        action: () => statusAction(0),
      },
      {
        menu_name: 'Pause Now',
        id: 'pause_now',
        icon: PauseAction,
        action: () => statusAction(3),
      },
      {
        menu_name: 'Edit Campaign',
        id: 'edit_campaign',
        icon: Pen,
        action: () => editAction(),
      },
      {
        menu_name: 'Duplicate',
        id: 'duplicate',
        icon: Duplicate,
        action: duplicateAction,
      },
    ],
    [statusAction],
  );
  return (
    <DropdownMenu isOpen={isOpen} setIsOpen={setIsOpen} BtnElement={DropdownBtn}>
      {allMenuItems.map((item) => {
        const isShow = menuItemsList?.includes(item.id);
        if (!isShow) return null;
        return (
          <MenuItem
            height={40}
            icon={item.icon}
            value={item.menu_name}
            id={item.id}
            onClick={item.action}
            key={item.id}
          >
            {item.menu_name}
          </MenuItem>
        );
      })}
    </DropdownMenu>
  );
};

const DropdownBtn = forwardRef((props, ref) => {
  return (
    <IconButton.SmallSizeBigIcon
      onClick={props.onClick}
      ref={ref}
      icon={DotMenuIcon}
      type={IconButton.btnTypes.tertiary}
      isPressed={props.isPressed}
    />
  );
});
DropdownBtn.displayName = 'DropdownBtn';
